import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";
import { URLS } from "../../redux/api/Constants";
import { get, post } from "../../redux/api/ApiHandler";
import toast from "react-hot-toast";

const FaultAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type; // "add" | "edit" | "view"
  const existingData = location.state?.data; // Prefill for edit/view
  const isViewMode = formType === "view";
  const isEditMode = formType === "edit";
  const type = location.state.type;
  const id = location?.state?.id;
  const data = location?.state?.data;
  // console.log("location", location?.state);


  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      faultName: "",
    },
  });



  const addAdmin = async () => {
    const values = getValues(); // 👈 get all form field values

    let payload = {
      name: values.faultName,
      type: 3,
      status: 1,
    };
    if (type == "add") {
      let res = await post(URLS.MASTERADD, payload)
      if (res?.status == "success") {
        toast.success(res?.message);
        navigate("/fault-type");
      }
    } else {
      let res = await post(URLS.MASTERUPDATE + id, payload)
      if (res?.status == "success") {
        toast.success(res?.message);
        navigate("/fault-type");
      }
    }
    console.log("Payload:", payload);
  };




  useEffect(() => {
    if (type != "add") {
      setValue("faultName", data?.name);

    }
  }, [])




  // // 🧩 Dummy data to show when editing or viewing
  // const dummyData = {
  //   faultName: "Power supply issue in the control panel due to loose wiring.",
  // };

  // // 🔁 Prefill when editing or viewing
  // useEffect(() => {
  //   if (isViewMode || isEditMode) {
  //     Object.entries(dummyData).forEach(([key, value]) => {
  //       setValue(key, value);
  //     });
  //   }
  // }, [isViewMode, isEditMode, setValue]);

  const onSubmit = (data) => {
    addAdmin(data);
    console.log("Submitted Data:", data);
    if (isEditMode) {
      console.log("Updating fault type...");
    } else {
      console.log("Adding new fault type...");
    }
    // navigate("/region");
  };



  return (
    <div>
      <Topbar
        header="Fault Type"
        subHead={isViewMode ? "View" : isEditMode ? "Edit" : "Add"}
      />
      <div className="container_fluit1 px-4 py-3">
        <form
          className="d-flex flex-wrap gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="col-md-5">
            <Controller
              control={control}
              name="faultName"
              rules={{ required: "Fault Name is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Fault Name
                  </label>
                  <textarea
                    {...field}
                    placeholder="-Enter Issue Type-"
                    className="form-control f2 fs-sm-13 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-15"
                    style={{
                      borderRadius: "8px",
                      borderColor: "#D9D9D9",
                      width: "100%",
                      minHeight: "100px",
                      padding: "10px",
                      fontSize: "10px",
                      resize: "vertical",
                      outline: "none",
                    }}
                    disabled={isViewMode}
                  />
                  {errors.faultName && (
                    <p style={{ color: "red", marginTop: "5px" }}>
                      {errors.faultName.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
        </form>

        {/* Buttons */}
        <div className="d-flex col-md-11 button_submit ac-jb my-3">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="back_btn f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            Back
          </button>
          {!isViewMode && (
            <button
              type="submit"
              onClick={handleSubmit(onSubmit)}
              className="Add_btn f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
            >
              {isEditMode ? "Save" : "Submit"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FaultAdd;
